'use strict';

exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var AndroidIcon = function AndroidIcon(props) {
  return _react2.default.createElement(
    'svg',
    _extends({
      xmlns: 'http://www.w3.org/2000/svg',
      width: '18',
      height: '18',
      viewBox: '0 0 18 18'
    }, props),
    _react2.default.createElement('path', {
      d: 'M3 6c-.56 0-1 .496-1 1v5c0 .505.44 1 1 1s1-.496 1-1V7c0-.504-.44-1-1-1zm2.642 8.03L7 14v3s0 1 1 1 1-1 1-1v-3h1v3s-.054.97 1 1c1-.03 1-1 1-1v-3h1c1.017 0 1.328-.414 1.328-.956V6H4.642l-.056 7.044c0 .542.424.987 1.056.987zm6.255-12.465l.816-1.29a.18.18 0 0 0-.051-.246.17.17 0 0 0-.24.052l-.845 1.335A5.398 5.398 0 0 0 9.486 1c-.75 0-1.457.15-2.092.416L6.55.08A.171.171 0 0 0 6.308.03a.18.18 0 0 0-.05.246l.816 1.29C5.602 2.304 4.61 3.696 4.61 5.294c0 .098.006.195.014.29h9.724c.008-.095.013-.192.013-.29 0-1.598-.993-2.99-2.464-3.73zm-4.666 2.31a.473.473 0 0 1-.468-.48c0-.265.21-.478.468-.478.26 0 .468.213.468.478 0 .266-.21.48-.468.48zm4.508 0a.473.473 0 0 1-.468-.48c0-.265.21-.478.468-.478.26 0 .468.213.468.478a.472.472 0 0 1-.468.48zM16 6c-.56 0-1 .496-1 1v5c0 .505.442 1 1 1 .561 0 1-.496 1-1V7c0-.504-.44-1-1-1z',
      stroke: 'currentColor',
      fill: 'currentColor',
      fillRule: 'evenodd'
    })
  );
};

var AppleIcon = function AppleIcon(props) {
  return _react2.default.createElement(
    'svg',
    _extends({
      xmlns: 'http://www.w3.org/2000/svg',
      width: '18',
      height: '18',
      viewBox: '0 0 18 18'
    }, props),
    _react2.default.createElement('path', {
      stroke: 'currentColor',
      fill: 'currentColor',
      d: 'M11.952 2.766c.689-.733 1.154-1.751 1.027-2.766-.992.035-2.194.58-2.907 1.312-.638.65-1.197 1.686-1.048 2.681 1.107.075 2.238-.495 2.928-1.227zm1.743 7.205c-.02-2.168 1.776-3.21 1.856-3.26-1.01-1.473-2.584-1.675-3.144-1.697-1.34-.136-2.612.784-3.292.784-.677 0-1.725-.766-2.836-.746-1.46.023-2.807.846-3.557 2.149-1.517 2.621-.389 6.505 1.09 8.631.723 1.041 1.583 2.21 2.713 2.167 1.091-.042 1.502-.702 2.818-.702 1.317 0 1.686.702 2.838.68 1.172-.02 1.914-1.06 2.63-2.105.83-1.207 1.171-2.376 1.19-2.435-.024-.014-2.282-.872-2.306-3.466z'
    })
  );
};

var ArrowBackIcon = function ArrowBackIcon(props) {
  return _react2.default.createElement(
    'svg',
    _extends({
      xmlns: 'http://www.w3.org/2000/svg',
      width: '32',
      height: '32',
      viewBox: '0 0 32 32'
    }, props),
    _react2.default.createElement('path', {
      fillRule: 'evenodd',
      d: 'M28.788 14.744H6.138l5.405-5.6a1.288 1.288 0 0 0 0-1.776 1.182 1.182 0 0 0-1.714 0l-7.474 7.744a1.288 1.288 0 0 0 0 1.776l7.474 7.744c.236.245.547.368.857.368.31 0 .62-.123.857-.368a1.288 1.288 0 0 0 0-1.776l-5.405-5.6h22.65c.67 0 1.212-.563 1.212-1.256 0-.694-.543-1.256-1.212-1.256z'
    })
  );
};

var ArrowRightIcon = function ArrowRightIcon(props) {
  return _react2.default.createElement(
    'svg',
    _extends({
      width: '14',
      height: '12',
      viewBox: '0 0 14 12',
      xmlns: 'http://www.w3.org/2000/svg'
    }, props),
    _react2.default.createElement('path', {
      d: 'M6.978 10.475c.222.149.48.223.77.223.29 0 .594-.151.91-.455l.77-.752a87.828 87.828 0 0 0 2.395-2.413l1.151-1.207-1.151-1.206A87.662 87.662 0 0 0 9.428 2.25l-.826-.798c-.278-.272-.548-.408-.808-.408h-.092c-.198 0-.36.024-.483.074-.124.05-.247.124-.371.223-.13.105-.248.222-.353.352a1.48 1.48 0 0 0-.223.372c-.05.123-.074.278-.074.464 0 .185.025.34.074.464.056.13.143.266.26.408.118.149.279.319.483.51l.492.474H2.569c-.304 0-.542.05-.715.149-.173.105-.31.204-.409.297a2.5 2.5 0 0 0-.297.408A1.255 1.255 0 0 0 1 5.871c0 .248.05.458.149.631.105.174.204.31.297.409a2.5 2.5 0 0 0 .408.297c.173.099.411.148.715.148h4.864l-.799.882c-.29.322-.436.628-.436.92 0 .284.074.537.223.76.154.217.34.402.557.557',
      stroke: 'currentColor',
      fill: 'none',
      fillRule: 'evenodd',
      opacity: '.5'
    })
  );
};

var BikeIcon = function BikeIcon(props) {
  return _react2.default.createElement(
    'svg',
    _extends({
      width: '16',
      height: '16',
      viewBox: '0 0 16 10',
      xmlns: 'http://www.w3.org/2000/svg'
    }, props),
    _react2.default.createElement(
      'g',
      {
        fill: 'currentColor',
        fillRule: 'evenodd'
      },
      _react2.default.createElement('path', {
        d: 'M3.115 10C1.397 10 0 8.54 0 6.747c0-1.794 1.397-3.254 3.115-3.254 1.717 0 3.115 1.46 3.115 3.254S4.832 10 3.115 10zm0-5.788C1.777 4.212.689 5.35.689 6.746c0 1.398 1.088 2.535 2.426 2.535 1.337 0 2.426-1.137 2.426-2.535 0-1.397-1.089-2.534-2.426-2.534z'
      }),
      _react2.default.createElement('path', {
        d: 'M6.67 7.055H3.124a.336.336 0 0 1-.286-.164.354.354 0 0 1-.016-.336l2.201-4.581a.337.337 0 0 1 .303-.193h6.697c.142 0 .27.091.318.228a.353.353 0 0 1-.102.384L6.886 6.974a.33.33 0 0 1-.216.08zm-2.998-.65h2.876L11.082 2.5H5.537L3.672 6.404z'
      }),
      _react2.default.createElement('path', {
        d: 'M7.008 7.055a.337.337 0 0 1-.316-.225L4.71 1.357a.348.348 0 0 1 .198-.445.334.334 0 0 1 .433.204l1.982 5.473a.348.348 0 0 1-.198.444.328.328 0 0 1-.117.022M12.854 7.02c-.16 0-.3-.116-.33-.284L11.415.406a.354.354 0 0 1 .073-.282.332.332 0 0 1 .257-.124h1.109c.408 0 1.015.26 1.015.978 0 .71-.575.988-.961 1.002h-.013a.34.34 0 0 1-.335-.332.341.341 0 0 1 .324-.358c.115-.007.314-.058.314-.312 0-.244-.217-.285-.347-.287h-.705l1.038 5.923a.344.344 0 0 1-.33.407'
      }),
      _react2.default.createElement('path', {
        d: 'M7.705 6.644c0 .34-.264.616-.59.616a.604.604 0 0 1-.59-.616c0-.34.264-.617.59-.617.326 0 .59.277.59.617M4.984.976c0 .33-.257.6-.574.6a.587.587 0 0 1-.574-.6c0-.331.257-.6.574-.6.317 0 .574.269.574.6'
      }),
      _react2.default.createElement('path', {
        d: 'M4.197.753a.37.37 0 0 1-.361.377c-.2 0-.36-.169-.36-.377s.16-.376.36-.376c.2 0 .36.168.36.376M6.525.685c0 .17-.133.308-.296.308a.302.302 0 0 1-.295-.308c0-.17.132-.308.295-.308.163 0 .296.138.296.308'
      }),
      _react2.default.createElement('path', {
        d: 'M3.86.377L6.174.38l.12.609-1.77.576-.108.01s-.616 0-.876-.645M12.885 10C11.168 10 9.77 8.54 9.77 6.747c0-1.794 1.398-3.254 3.115-3.254 1.717 0 3.115 1.46 3.115 3.254S14.602 10 12.885 10zm0-5.788c-1.338 0-2.426 1.137-2.426 2.534 0 1.398 1.088 2.535 2.426 2.535s2.426-1.137 2.426-2.535c0-1.397-1.088-2.534-2.426-2.534z'
      })
    )
  );
};

var BinIcon = function BinIcon(props) {
  return _react2.default.createElement(
    'svg',
    _extends({
      width: '12',
      height: '12',
      viewBox: '0 0 12 12',
      xmlns: 'http://www.w3.org/2000/svg'
    }, props),
    _react2.default.createElement(
      'g',
      {
        fill: 'currentColor',
        fillRule: 'evenodd',
        opacity: '.5'
      },
      _react2.default.createElement('path', {
        d: 'M8.571 1.667l-.005-.31C8.566.609 7.92 0 7.125 0H4.532c-.794 0-1.441.609-1.441 1.357l-.005.31H.343c-.188 0-.348.146-.343.333-.005.193.14.328.343.333h.686v7.837C1.02 11.178 1.894 12 2.967 12H8.69c1.073 0 1.946-.822 1.939-1.833V2.333h.685c.202 0 .363-.143.343-.333.02-.19-.162-.333-.343-.333H8.571zm-4.8-.384c0-.34.329-.616.731-.616h2.653c.403 0 .73.276.73.616v.384H3.772v-.384zm6.17 8.886c0 .642-.552 1.164-1.229 1.164h-5.77c-.676 0-1.228-.522-1.228-1.164V2.333h8.229v8.17l-.003-.334z'
      }),
      _react2.default.createElement('path', {
        d: 'M5.829 10c.19 0 .342-.15.342-.333v-6a.338.338 0 0 0-.342-.334c-.19 0-.343.15-.343.334v6c0 .18.152.333.343.333zM3.429 9.667a.34.34 0 0 0 .342-.334V4a.34.34 0 0 0-.342-.333.34.34 0 0 0-.343.333v5.333c0 .181.155.334.343.334zM8.571 9.333V4a.34.34 0 0 0-.342-.333.34.34 0 0 0-.343.333v5.333c0 .181.152.334.343.334a.34.34 0 0 0 .342-.334z'
      })
    )
  );
};

var BuildingPin = function BuildingPin(props) {
  return _react2.default.createElement(
    'svg',
    _extends({
      width: '12',
      height: '17',
      viewBox: '0 0 12 17',
      xmlns: 'http://www.w3.org/2000/svg'
    }, props),
    _react2.default.createElement(
      'g',
      {
        fill: 'none',
        fillRule: 'evenodd'
      },
      _react2.default.createElement('path', {
        d: 'M7.958 16.333v-3a.5.5 0 0 0-.5-.5h-3.25a.5.5 0 0 0-.5.5v3H.958v-13.5a1.5 1.5 0 0 1 1.5-1.5h6.75a1.5 1.5 0 0 1 1.5 1.5v13.5h-2.75z',
        stroke: 'currentColor'
      }),
      _react2.default.createElement('path', {
        fill: 'currentColor',
        d: 'M3.208 3.583h1.75v2.625h-1.75zm3.5 0h1.75v2.625h-1.75zm-3.5 4.375h1.75v2.625h-1.75zm3.5 0h1.75v2.625h-1.75z'
      })
    )
  );
};

var CalendarIcon = function CalendarIcon(props) {
  return _react2.default.createElement(
    'svg',
    _extends({
      width: '16',
      height: '16',
      viewBox: '0 0 16 16',
      xmlns: 'http://www.w3.org/2000/svg'
    }, props),
    _react2.default.createElement(
      'g',
      {
        fill: 'currentColor',
        fillRule: 'evenodd',
        opacity: '.5'
      },
      _react2.default.createElement('path', {
        d: 'M14.667 1.5H12.5v-1a.5.5 0 1 0-1 0v1h-3v-1a.5.5 0 1 0-1 0v1h-3v-1a.5.5 0 1 0-1 0v1H1.333C.597 1.5 0 2.096 0 2.833v11.833C0 15.403.597 16 1.333 16h13.334c.736 0 1.333-.597 1.333-1.334V2.833c0-.737-.597-1.333-1.333-1.333zM15 14.666c0 .184-.15.334-.333.334H1.333A.334.334 0 0 1 1 14.666V2.833c0-.183.15-.333.333-.333H3.5v1a.5.5 0 1 0 1 0v-1h3v1a.5.5 0 1 0 1 0v-1h3v1a.5.5 0 1 0 1 0v-1h2.167c.184 0 .333.15.333.333v11.833z'
      }),
      _react2.default.createElement('path', {
        d: 'M4 7h2v1H4zM4 9h2v1H4zM4 11h2v1H4zM7 11h2v1H7zM7 9h2v1H7zM7 7h2v1H7zM10 11h2v1h-2zM10 9h2v1h-2zM10 7h2v1h-2z'
      })
    )
  );
};

var CardIcon = function CardIcon(props) {
  return _react2.default.createElement(
    'svg',
    _extends({
      version: '1',
      xmlns: 'http://www.w3.org/2000/svg',
      width: '1200',
      height: '1200',
      viewBox: '0 0 900.000000 900.000000'
    }, props),
    _react2.default.createElement(
      'g',
      {
        fill: 'currentColor'
      },
      _react2.default.createElement('path', {
        d: 'M103.5 157.7c-9.1 1.1-20.8 3.4-22.4 4.3-1.1.5-2.8 1-3.8 1s-6.1 2.2-11.4 4.9C38.3 181.8 21.2 203 12.4 234c-1.8 6.2-1.9 15-1.9 217 0 198.3.1 210.7 1.8 214.4.9 2.1 1.7 4.7 1.7 5.7 0 2.9 4.7 13.5 9.9 22.4 13.4 23 38.2 41 64.7 46.9 6.5 1.5 40.2 1.6 360.4 1.6s353.9-.1 360.4-1.6c26.5-5.9 51.3-23.9 64.7-46.9 5.2-8.9 9.9-19.5 9.9-22.4 0-1 .8-3.6 1.7-5.7 1.7-3.7 1.8-16.1 1.8-214.4 0-202-.1-210.8-1.9-217-6.9-24.3-19.8-43.6-38-56.9-6.6-4.9-24.2-14.1-26.9-14.1-1 0-2.7-.5-3.7-1-1.1-.6-5.7-1.8-10.2-2.7-7.7-1.6-32.3-1.8-354.3-1.9-190.3-.1-347.3.1-349 .3zm701 49.4c9.7 3.4 12 4.8 21 12.8 7 6.2 12.6 16.9 14.9 28.1 1.3 6.6 1.7 12.5 1.4 26l-.3 17.5h-785l-.3-17.5c-.3-21.1 1.3-31.2 6.5-40.9 1.9-3.5 4-7 4.8-7.8.8-.8 2-2.2 2.7-3.1 1.7-2.3 10.7-9.5 13.8-11.2 1.4-.8 5.2-2.4 8.5-3.6l6-2.3h350l350.1-.1 5.9 2.1zm37.3 149.6c.2 13.7 0 16.4-1.3 17.7-1.5 1.5-35.9 1.6-391.5 1.6-353.1 0-390-.1-391.4-1.6-1.3-1.3-1.6-4.3-1.6-17.3 0-8.7.3-16.1.7-16.4.3-.4 177.1-.6 392.7-.5l392.1.3.3 16.2zm-.8 67.2c.7 1.3 1 37.8 1 111.1 0 119.9.1 117.8-6 130.5-7.4 15.1-21.7 26.3-37.5 29.1-5.5 1-78.2 1.3-349.5 1.3s-344-.3-349.5-1.3c-15.8-2.8-30.1-14-37.5-29.1-6.1-12.7-6-10.6-6-130.5 0-73.3.3-109.8 1-111.1 1.1-1.9 6.5-1.9 392-1.9s390.9 0 392 1.9z'
      }),
      _react2.default.createElement('path', {
        d: 'M134.1 594c-8.7 4.9-12.1 10.9-12.1 21.6 0 10.9 4.6 18.3 13.9 22.5 4.1 1.8 6.9 1.9 46 1.9 46.4 0 45.9 0 53-7.1 9.5-9.5 9.5-25.5-.1-34.5-6.9-6.6-5.3-6.4-53.5-6.3-41 0-44 .1-47.2 1.9zM314.1 594c-8.7 4.9-12.1 10.9-12.1 21.6 0 10.9 4.6 18.3 13.9 22.5 4.1 1.8 6.9 1.9 46 1.9 46.4 0 45.9 0 53-7.1 9.5-9.5 9.5-25.5-.1-34.5-6.9-6.6-5.3-6.4-53.5-6.3-41 0-44 .1-47.2 1.9z'
      })
    )
  );
};

var CarIcon = function CarIcon(props) {
  return _react2.default.createElement(
    'svg',
    _extends({
      width: '16',
      height: '16',
      viewBox: '0 0 17 10',
      xmlns: 'http://www.w3.org/2000/svg'
    }, props),
    _react2.default.createElement(
      'g',
      {
        fill: 'currentColor',
        fillRule: 'evenodd'
      },
      _react2.default.createElement('path', {
        d: 'M.362 8.032a.354.354 0 0 1-.359-.349c0-2.072.272-4.02 2.219-4.304.127-.205.322-.892.455-1.361.1-.35.202-.712.3-.998C3.338-.021 5.039.003 5.855.013l.157.002 3.266.004c.092 0 .21 0 .33.028 2.201.511 2.504 2.372 2.633 3.167.01.058.02.122.03.165.412.02.967.013 1.767.062 1.375.085 2.931 1.742 2.931 4.242 0 .193-.16.349-.358.349H.362zm15.872-.695c-.124-1.55-1.058-3.113-2.199-3.199-.805-.06-1.789-.05-2.009-.065-.371-.008-.43-.369-.492-.75-.125-.768-.357-2.198-2.09-2.601-.037-.009-.097-.008-.16-.009L5.851.707C5.358.7 3.86.68 3.668 1.24c-.092.268-.192.621-.29.963-.368 1.303-.535 1.834-.957 1.876-.998.099-1.632.69-1.683 3.26h15.496z'
      }),
      _react2.default.createElement('path', {
        d: 'M2.347 3.379h9.79v.694h-9.79V3.38z'
      }),
      _react2.default.createElement('path', {
        d: 'M7.594.323h.7v3.403h-.7V.323zM3.222 9.976a2.101 2.101 0 0 1-2.09-2.28.355.355 0 0 1 .354-.324h3.471c.185 0 .34.141.355.326a2.101 2.101 0 0 1-2.09 2.279zm-1.365-1.91c.099.667.673 1.18 1.364 1.18.692 0 1.266-.513 1.364-1.18H1.857zM13.12 9.976a2.101 2.101 0 0 1-2.09-2.28.355.355 0 0 1 .355-.324h3.472c.184 0 .338.141.354.326a2.101 2.101 0 0 1-2.09 2.279zm-1.364-1.91c.099.667.673 1.18 1.365 1.18.69 0 1.265-.513 1.364-1.18h-2.729z'
      })
    )
  );
};

var CheckIcon = function CheckIcon(props) {
  return _react2.default.createElement(
    'svg',
    _extends({
      width: '8',
      height: '6',
      viewBox: '0 0 8 6',
      xmlns: 'http://www.w3.org/2000/svg'
    }, props),
    _react2.default.createElement('path', {
      d: 'M8 .5l-5.157 5L0 2.798',
      stroke: 'currentColor',
      fill: 'none',
      fillRule: 'evenodd',
      strokeLinecap: 'round',
      strokeLinejoin: 'round'
    })
  );
};

var CheckIconV2 = function CheckIconV2(props) {
  return _react2.default.createElement(
    'svg',
    _extends({
      width: '15',
      height: '11',
      viewBox: '0 0 15 11',
      fill: 'none',
      xmlns: 'http://www.w3.org/2000/svg'
    }, props),
    _react2.default.createElement('path', {
      d: 'M13.89.065h-1.604c-.348 0-.68.168-.885.455L6.028 7.971 3.594 4.594a1.093 1.093 0 0 0-.885-.454H1.106c-.222 0-.352.253-.222.434l4.259 5.906a1.088 1.088 0 0 0 1.767 0L14.108.5a.272.272 0 0 0-.219-.435z',
      fill: '#6C65F7'
    })
  );
};

var ChevronDownIcon = function ChevronDownIcon(props) {
  return _react2.default.createElement(
    'svg',
    _extends({
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      xmlns: 'http://www.w3.org/2000/svg'
    }, props),
    _react2.default.createElement('path', {
      d: 'M4 10l8 6 8-6',
      stroke: 'currentColor',
      fill: 'none',
      fillRule: 'evenodd',
      strokeLinecap: 'round',
      strokeLinejoin: 'round'
    })
  );
};

var ChevronLeftIcon = function ChevronLeftIcon(props) {
  return _react2.default.createElement(
    'svg',
    _extends({
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      xmlns: 'http://www.w3.org/2000/svg'
    }, props),
    _react2.default.createElement('path', {
      d: 'M14 4l-6 8 6 8',
      stroke: 'currentColor',
      fill: 'none',
      fillRule: 'evenodd',
      strokeLinecap: 'round',
      strokeLinejoin: 'round'
    })
  );
};

var ChevronRightIcon = function ChevronRightIcon(props) {
  return _react2.default.createElement(
    'svg',
    _extends({
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      xmlns: 'http://www.w3.org/2000/svg'
    }, props),
    _react2.default.createElement('path', {
      d: 'M10 20l6-8-6-8',
      stroke: 'currentColor',
      fill: 'none',
      fillRule: 'evenodd',
      strokeLinecap: 'round',
      strokeLinejoin: 'round'
    })
  );
};

var ChevronUpIcon = function ChevronUpIcon(props) {
  return _react2.default.createElement(
    'svg',
    _extends({
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      xmlns: 'http://www.w3.org/2000/svg'
    }, props),
    _react2.default.createElement('path', {
      d: 'M20 14l-8-6-8 6',
      stroke: 'currentColor',
      fill: 'none',
      fillRule: 'evenodd',
      strokeLinecap: 'round',
      strokeLinejoin: 'round'
    })
  );
};

var ClockIcon = function ClockIcon(props) {
  return _react2.default.createElement(
    'svg',
    _extends({
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      xmlns: 'http://www.w3.org/2000/svg'
    }, props),
    _react2.default.createElement(
      'g',
      {
        transform: 'translate(4 4)',
        fill: 'none',
        fillRule: 'evenodd'
      },
      _react2.default.createElement('rect', {
        fill: 'currentColor',
        x: '7',
        y: '3',
        width: '1',
        height: '6',
        rx: '.5'
      }),
      _react2.default.createElement('rect', {
        fill: 'currentColor',
        x: '7',
        y: '8',
        width: '4',
        height: '1',
        rx: '.5'
      }),
      _react2.default.createElement('circle', {
        stroke: 'currentColor',
        cx: '8',
        cy: '8',
        r: '8'
      })
    )
  );
};

var CommentIcon = function CommentIcon(props) {
  return _react2.default.createElement(
    'svg',
    _extends({
      width: '16',
      height: '16',
      viewBox: '0 0 16 16',
      xmlns: 'http://www.w3.org/2000/svg'
    }, props),
    _react2.default.createElement(
      'g',
      {
        transform: 'translate(2 2)',
        fill: 'none',
        fillRule: 'evenodd'
      },
      _react2.default.createElement('path', {
        d: 'M10.412 9.97C11.729 8.84 12.5 7.247 12.5 5.536 12.5 2.193 9.581-.5 6-.5S-.5 2.193-.5 5.536c0 3.343 2.919 6.037 6.5 6.037.557 0 1.105-.066 1.635-.193.971.414 1.81.745 2.402.936.466.15.754.213.98.172a.558.558 0 0 0 .414-.805c-.066-.14-.179-.265-.355-.419-.315-.274-.536-.716-.664-1.294z',
        stroke: 'currentColor'
      }),
      _react2.default.createElement('circle', {
        fill: 'currentColor',
        cx: '3',
        cy: '5.5',
        r: '1'
      }),
      _react2.default.createElement('circle', {
        fill: 'currentColor',
        cx: '6',
        cy: '5.5',
        r: '1'
      }),
      _react2.default.createElement('circle', {
        fill: 'currentColor',
        cx: '9',
        cy: '5.5',
        r: '1'
      })
    )
  );
};

var FacebookIcon = function FacebookIcon(props) {
  return _react2.default.createElement(
    'svg',
    _extends({
      width: '18',
      height: '18',
      viewBox: '0 0 18 18',
      xmlns: 'http://www.w3.org/2000/svg'
    }, props),
    _react2.default.createElement('path', {
      d: 'M16 0H2C.9 0 0 .9 0 2v14c0 1.101.9 2 2 2h7v-7H7V8.525h2v-2.05c0-2.164 1.212-3.684 3.766-3.684l1.803.002v2.605h-1.197c-.994 0-1.372.746-1.372 1.438v1.69h2.568L14 11h-2v7h4c1.1 0 2-.899 2-2V2c0-1.1-.9-2-2-2z',
      fill: 'currentColor',
      fillRule: 'evenodd'
    })
  );
};

var HeartIcon = function HeartIcon(props) {
  return _react2.default.createElement(
    'svg',
    _extends({
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      xmlns: 'http://www.w3.org/2000/svg',
      xmlnsXlink: 'http://www.w3.org/1999/xlink'
    }, props),
    _react2.default.createElement(
      'defs',
      null,
      _react2.default.createElement('path', {
        d: 'M10.505 1.568L10 2.053l-.505-.485c-2.175-2.09-5.713-2.09-7.888 0-2.13 2.048-2.144 5.293-.032 7.55 1.926 2.058 7.608 6.503 7.85 6.691.163.128.36.19.555.19a.893.893 0 0 0 .595-.19c.241-.188 5.923-4.633 7.85-6.691 2.112-2.257 2.098-5.502-.032-7.55-2.175-2.09-5.714-2.09-7.888 0z',
        id: 'a'
      }),
      _react2.default.createElement(
        'mask',
        {
          id: 'b',
          x: '0',
          y: '0',
          width: '20',
          height: '16',
          fill: '#fff'
        },
        _react2.default.createElement('use', {
          xlinkHref: '#a'
        })
      )
    ),
    _react2.default.createElement('use', {
      mask: 'url(#b)',
      xlinkHref: '#a',
      transform: 'translate(2 4)',
      strokeWidth: '2',
      stroke: 'currentColor',
      fill: 'none',
      fillRule: 'evenodd',
      strokeLinecap: 'round',
      strokeLinejoin: 'round'
    })
  );
};

var InstagramIcon = function InstagramIcon(props) {
  return _react2.default.createElement(
    'svg',
    _extends({
      width: '18',
      height: '18',
      viewBox: '0 0 18 18',
      xmlns: 'http://www.w3.org/2000/svg'
    }, props),
    _react2.default.createElement('path', {
      d: 'M16 0H2C.9 0 0 .9 0 2v14c0 1.101.9 2 2 2h14c1.1 0 2-.899 2-2V2c0-1.1-.9-2-2-2zM8.984 14.523a5.539 5.539 0 0 0 5.538-5.539c0-.338-.043-.664-.103-.984H16v7.216a.69.69 0 0 1-.693.69H2.693a.69.69 0 0 1-.693-.69V8h1.549c-.061.32-.104.646-.104.984a5.54 5.54 0 0 0 5.539 5.539zM5.523 8.984a3.461 3.461 0 1 1 6.922 0 3.461 3.461 0 0 1-6.922 0zM15.307 5h-1.615A.694.694 0 0 1 13 4.308V2.691c0-.382.31-.691.691-.691h1.615c.384 0 .694.309.694.691v1.616c0 .381-.31.693-.693.693z',
      fill: 'currentColor',
      fillRule: 'evenodd'
    })
  );
};

var ItemBoxIcon = function ItemBoxIcon(props) {
  return _react2.default.createElement(
    'svg',
    _extends({
      width: '34',
      height: '35',
      viewBox: '0 0 34 35',
      xmlns: 'http://www.w3.org/2000/svg'
    }, props),
    _react2.default.createElement(
      'g',
      {
        fill: 'none',
        fillRule: 'evenodd'
      },
      _react2.default.createElement('path', {
        d: 'M.81 8.382L17 15.512V35L.81 27.692V8.382zm32.38-.177L17 15.513V35l16.19-7.308V8.205z',
        fill: '#000',
        opacity: '.08'
      }),
      _react2.default.createElement('path', {
        fill: '#4AC7D6',
        d: 'M.81 6.673L17 13.803v19.488L.81 25.983z'
      }),
      _react2.default.createElement('path', {
        fill: '#38AEBD',
        d: 'M33.19 6.496L17 13.803v19.488l16.19-7.308z'
      }),
      _react2.default.createElement('path', {
        d: 'M.783 6.657L17 .274l16.21 6.23L17 14.784.783 6.656z',
        fill: '#5DDAE8'
      })
    )
  );
};

var ListMove = function ListMove(props) {
  return _react2.default.createElement(
    'svg',
    _extends({
      xmlns: 'http://www.w3.org/2000/svg',
      width: '16',
      height: '16',
      viewBox: '0 0 16 16'
    }, props),
    _react2.default.createElement(
      'g',
      {
        fill: 'currentColor',
        fillRule: 'evenodd'
      },
      _react2.default.createElement('circle', {
        cx: '5',
        cy: '4',
        r: '1'
      }),
      _react2.default.createElement('circle', {
        cx: '8',
        cy: '4',
        r: '1'
      }),
      _react2.default.createElement('circle', {
        cx: '11',
        cy: '4',
        r: '1'
      }),
      _react2.default.createElement('circle', {
        cx: '5',
        cy: '7',
        r: '1'
      }),
      _react2.default.createElement('circle', {
        cx: '8',
        cy: '7',
        r: '1'
      }),
      _react2.default.createElement('circle', {
        cx: '11',
        cy: '7',
        r: '1'
      }),
      _react2.default.createElement('circle', {
        cx: '5',
        cy: '10',
        r: '1'
      }),
      _react2.default.createElement('circle', {
        cx: '8',
        cy: '10',
        r: '1'
      }),
      _react2.default.createElement('circle', {
        cx: '11',
        cy: '10',
        r: '1'
      }),
      _react2.default.createElement('circle', {
        cx: '5',
        cy: '13',
        r: '1'
      }),
      _react2.default.createElement('circle', {
        cx: '8',
        cy: '13',
        r: '1'
      }),
      _react2.default.createElement('circle', {
        cx: '11',
        cy: '13',
        r: '1'
      })
    )
  );
};

var LocationIcon = function LocationIcon(props) {
  return _react2.default.createElement(
    'svg',
    _extends({
      width: '16',
      height: '16',
      viewBox: '0 0 16 16',
      xmlns: 'http://www.w3.org/2000/svg'
    }, props),
    _react2.default.createElement('path', {
      d: 'M7.968 1C5.995.999 4 2.487 4 5.131c0 2.645 2.332 7.322 3.4 9.482a.665.665 0 0 0 1.207 0C9.674 12.453 12 7.703 12 5.131 12 2.56 10.179 1.001 7.968 1zM10 5a2 2 0 1 1-4 0 2 2 0 0 1 4 0z',
      stroke: 'currentColor',
      fillRule: 'evenodd'
    })
  );
};

var LogoIcon = function LogoIcon(props) {
  return _react2.default.createElement(
    'svg',
    _extends({
      width: '16',
      height: '16',
      viewBox: '0 0 113 36',
      xmlns: 'http://www.w3.org/2000/svg'
    }, props),
    _react2.default.createElement('path', {
      d: 'M53.044 12.525h-.345c-.906 0-1.567.416-1.567 1.663v13.658c0 1.246.661 1.619 1.567 1.619h.345c.905 0 1.523-.387 1.523-1.62V14.189c.014-1.276-.618-1.663-1.523-1.663zm-.187-6.964a2.113 2.113 0 0 0-2.113 2.106 2.113 2.113 0 0 0 4.225 0 2.104 2.104 0 0 0-2.112-2.106zm21.37 7.351v21.469c0 1.246-.618 1.619-1.524 1.619h-.388c-.862 0-1.523-.387-1.523-1.62v-7.738c-1.279 1.977-3.22 3.153-5.835 3.153-4.469 0-7.803-3.497-7.803-8.757s3.29-8.756 7.904-8.756c2.774 0 4.829 1.275 5.763 2.809.144-2.078 1.178-2.566 2.155-2.566.705 0 1.25.287 1.25.387zm-3.262 8.126c0-4.184-2.444-5.904-5.303-5.904-3.291 0-5.174 2.651-5.174 5.904 0 3.268 1.825 5.905 5.174 5.905 2.486 0 5.303-1.72 5.303-5.905zM113 21.01c0 5.23-3.291 8.785-7.904 8.785-2.745 0-4.786-1.49-5.72-3.11v7.696c0 1.246-.66 1.619-1.523 1.619h-.388c-.906 0-1.524-.387-1.524-1.62V12.913c0-.1.561-.387 1.25-.387 1.036 0 2.113.56 2.156 2.867 1.323-1.935 3.22-3.11 5.864-3.11 4.47 0 7.789 3.425 7.789 8.728zm-3.334.028c0-3.267-1.883-5.904-5.174-5.904-2.86 0-5.303 1.72-5.303 5.904 0 4.2 2.817 5.905 5.303 5.905 3.349 0 5.174-2.652 5.174-5.905zM43.602 31.887c1.265 1.146-.59 3.454-4.944 3.611-5.82.215-8.795-3.066-11.051-6.434-.776-1.161-1.567-2.437-2.573-3.67-4.627 4.616-11.381 5.676-14.687 2.38a6.316 6.316 0 0 1-1.854-4.486c0-1.748.705-3.339 1.854-4.485 3.306-3.297 9.945-2.422 14.572 2.192.518-.831.935-1.82 1.222-2.88.287-1.06.446-2.179.446-3.282A11.68 11.68 0 0 0 19.415 4.04a11.822 11.822 0 0 0-4.57-.917c-1.624 0-3.176.33-4.57.917A11.81 11.81 0 0 0 6.54 6.55a11.615 11.615 0 0 0-2.515 3.726 11.733 11.733 0 0 0-.201 8.6 11.562 11.562 0 0 0 1.983 3.439 1.198 1.198 0 0 1-.072 1.605l-.503.501a1.201 1.201 0 0 1-1.768-.086 14.785 14.785 0 0 1-2.543-4.37A14.58 14.58 0 0 1 0 14.817 14.734 14.734 0 0 1 4.354 4.342a15.003 15.003 0 0 1 4.729-3.181A14.953 14.953 0 0 1 14.86 0c2.055 0 4.01.416 5.777 1.16a14.767 14.767 0 0 1 4.728 3.182 14.957 14.957 0 0 1 3.19 4.715 14.84 14.84 0 0 1 .432 10.362 12.301 12.301 0 0 1-2.084 3.855c3.478 4.199 4.627 9.745 11.885 9.745 3.018.014 4.814-1.132 4.814-1.132zM23.31 23.274c-1.753-1.749-4.455-3.153-6.596-3.454-1.797-.258-3.363.115-4.297 1.046a3.399 3.399 0 0 0-1.006 2.422c0 .917.359 1.777 1.006 2.422.92.917 2.486 1.304 4.297 1.046 2.14-.33 4.843-1.734 6.596-3.482zm22.98-10.749H45.9c-.862 0-1.494.416-1.494 1.663v8.642c0 2.035-2.027 3.94-4.585 3.94-2.529 0-3.995-1.69-3.995-4.571v-8.025c0-1.276-.618-1.663-1.523-1.663h-.374c-.862 0-1.494.416-1.494 1.663v8.44c0 4.157 2.012 7.123 6.423 7.123 2.573 0 4.412-1.204 5.548-2.909.1 2.107 1.15 2.623 2.184 2.623.661 0 1.207-.273 1.207-.387V14.159c.015-1.247-.618-1.634-1.509-1.634zm44.751 0h-.388c-.862 0-1.495.416-1.495 1.663v8.642c0 2.035-2.026 3.94-4.584 3.94-2.53 0-3.995-1.69-3.995-4.571v-8.025c0-1.276-.618-1.663-1.524-1.663h-.388c-.862 0-1.494.416-1.494 1.663v8.44c0 4.157 2.012 7.123 6.424 7.123 2.572 0 4.412-1.204 5.547-2.909.1 2.107 1.15 2.623 2.184 2.623.661 0 1.208-.273 1.208-.387V14.159c.028-1.247-.59-1.634-1.495-1.634z',
      fill: 'currentColor',
      fillRule: 'evenodd'
    })
  );
};

var PaperPlane = function PaperPlane(props) {
  return _react2.default.createElement(
    'svg',
    _extends({
      width: '14',
      height: '14',
      viewBox: '0 0 14 14',
      xmlns: 'http://www.w3.org/2000/svg'
    }, props),
    _react2.default.createElement('path', {
      d: 'M13.78.094a.488.488 0 0 1 .21.5l-2 11.993a.492.492 0 0 1-.25.351.48.48 0 0 1-.43.024l-4.116-1.68-2.328 2.554A.46.46 0 0 1 4.5 14a.445.445 0 0 1-.18-.031.47.47 0 0 1-.234-.184A.503.503 0 0 1 4 13.5V9.971L.312 8.464A.459.459 0 0 1 0 8.034a.456.456 0 0 1 .25-.46L13.248.078a.454.454 0 0 1 .531.016zm-2.672 11.704l1.726-10.33L1.632 7.925l2.625 1.07 6.741-4.99-3.734 6.224 3.844 1.57z',
      fill: 'currentColor',
      fillRule: 'evenodd'
    })
  );
};

var PhoneIcon = function PhoneIcon(props) {
  return _react2.default.createElement(
    'svg',
    _extends({
      width: '16',
      height: '16',
      viewBox: '0 0 16 16',
      xmlns: 'http://www.w3.org/2000/svg'
    }, props),
    _react2.default.createElement('path', {
      d: 'M4.493 11.507s4.75 4.775 8.425 3.16c3.927-1.56 1.337-3.398 0-3.862-1.503-.539-2.694-1.102-2.809.702 0 0-.62 1.557-3.86-1.755C3.007 6.439 4.492 5.89 4.492 5.89c1.805-.115 1.24-1.306.702-2.809-.464-1.337-2.302-3.927-3.861 0-1.616 3.675 3.159 8.425 3.159 8.425z',
      stroke: 'currentColor',
      fill: 'transparent',
      fillRule: 'evenodd'
    })
  );
};

var PinIcon = function PinIcon(props) {
  return _react2.default.createElement(
    'svg',
    _extends({
      width: '12',
      height: '18',
      viewBox: '0 0 12 18',
      xmlns: 'http://www.w3.org/2000/svg'
    }, props),
    _react2.default.createElement('path', {
      d: 'M11.356 6.413c0-2.989-2.318-5.412-5.176-5.413C3.63.999 1.425 3.008 1.053 5.647a5.58 5.58 0 0 0 .016 1.645v.004c.14 1.907 2.993 7.176 4.374 9.628a.835.835 0 0 0 1.47 0c1.38-2.452 4.234-7.72 4.373-9.628v-.004c.045-.286.07-.58.07-.879zm-2.772-.019c0 1.39-1.077 2.516-2.406 2.516-1.329 0-2.406-1.127-2.406-2.516 0-1.39 1.077-2.515 2.406-2.515 1.329 0 2.406 1.126 2.406 2.515z',
      stroke: 'currentColor',
      fillRule: 'evenodd'
    })
  );
};

var ProfileIcon = function ProfileIcon(props) {
  return _react2.default.createElement(
    'svg',
    _extends({
      width: '17',
      height: '20',
      viewBox: '0 0 17 20',
      xmlns: 'http://www.w3.org/2000/svg'
    }, props),
    _react2.default.createElement('path', {
      d: 'M8.5 10a4.5 4.5 0 1 1 0-9 4.5 4.5 0 0 1 0 9zM1 19v-3.045c0-2.607 1.953-4.746 4.436-4.95.258-.021.515.027.76.11a7.108 7.108 0 0 0 4.609 0c.244-.083.502-.131.759-.11 2.483.204 4.436 2.343 4.436 4.95V19H1z',
      stroke: 'currentColor',
      opacity: '.7',
      fill: 'none',
      fillRule: 'evenodd'
    })
  );
};

var QLogoIcon = function QLogoIcon(props) {
  return _react2.default.createElement(
    'svg',
    _extends({
      width: '819',
      height: '819',
      viewBox: '0 0 819 819',
      xmlns: 'http://www.w3.org/2000/svg'
    }, props),
    _react2.default.createElement(
      'g',
      {
        fillRule: 'nonzero',
        fill: 'none'
      },
      _react2.default.createElement('path', {
        d: 'M818.967 409.483c0 226.152-183.332 409.484-409.484 409.484C183.333 818.967 0 635.635 0 409.483 0 183.333 183.332 0 409.483 0c226.152 0 409.484 183.332 409.484 409.483',
        fill: '#6DE86D'
      }),
      _react2.default.createElement('path', {
        d: 'M439.115 612.076c-30.557 4.442-57.086-2.015-72.737-17.668-10.964-10.99-17.001-25.595-17.001-41.123 0-15.526 6.039-30.135 16.958-41.08 15.702-15.702 42.228-22.168 72.779-17.724 36.307 5.274 82.066 29.12 111.748 58.804-29.674 29.675-75.432 53.517-111.747 58.79zM744.257 651.7s-53.937-19.145-133.031-98.239c14.582-18.227 27.558-41.647 35.426-65.715 8.052-24.634 12.407-50.94 12.407-78.264 0-34.759-7.045-67.872-19.783-97.99-12.74-30.118-31.173-57.243-53.952-80.02-22.778-22.779-49.901-41.213-80.02-53.95-30.118-12.74-63.231-19.785-97.99-19.785-34.76 0-67.872 7.044-97.991 19.785-30.118 12.738-57.241 31.172-80.02 53.95-22.778 22.777-41.211 49.901-53.95 80.02-12.74 30.118-19.784 63.231-19.784 97.99 0 30.776 5.522 60.258 15.629 87.517 10.106 27.258 24.798 52.288 43.138 74.155a20.376 20.376 0 0 0 14.653 7.3c5.459.266 11.015-1.66 15.23-5.875l8.602-8.604a20.034 20.034 0 0 0 5.87-13.42 20.483 20.483 0 0 0-4.733-13.915c-14.32-17.25-25.783-36.953-33.667-58.387-7.884-21.436-12.19-44.6-12.19-68.77 0-27.505 5.576-53.708 15.656-77.542 10.08-23.834 24.668-45.296 42.693-63.322 18.025-18.025 39.488-32.612 63.322-42.692 23.833-10.08 50.037-15.655 77.542-15.655 27.506 0 53.709 5.575 77.543 15.655 23.833 10.08 45.297 24.667 63.322 42.692 18.025 18.026 32.612 39.488 42.693 63.322 10.08 23.834 15.655 50.036 15.655 77.541 0 18.752-2.745 37.89-7.67 55.88-4.927 17.99-12.034 34.83-20.762 48.984-78.387-78.386-190.873-93.315-246.902-37.285-19.475 19.524-31.516 46.466-31.516 76.222 0 29.758 12.04 56.7 31.516 76.225 56.013 56.012 170.53 38.048 248.902-40.323C669.3 678.39 709.609 690.633 709.609 690.633l34.648-38.933z',
        fill: '#FFF'
      })
    )
  );
};

var QuiqdashLogoIcon = function QuiqdashLogoIcon(props) {
  return _react2.default.createElement(
    'svg',
    _extends({
      width: '1040',
      height: '300',
      viewBox: '0 0 1040 300',
      xmlns: 'http://www.w3.org/2000/svg'
    }, props),
    _react2.default.createElement(
      'g',
      {
        fill: 'currentColor',
        fillRule: 'evenodd'
      },
      _react2.default.createElement('path', {
        d: 'M344.369 111.71h-2.657c-6.038 0-10.386 2.905-10.386 11.62v60.504c0 14.214-14.098 27.62-31.88 27.62-17.63 0-27.774-11.862-27.774-31.956V123.33c0-8.958-4.347-11.621-10.626-11.621h-2.658c-6.037 0-10.385 2.905-10.385 11.62v59.073c0 29.052 14.008 49.871 44.68 49.871 17.873 0 30.674-8.472 38.643-20.335.725 14.767 7.97 18.399 15.216 18.399 4.59 0 8.453-1.936 8.453-2.663V123.331c0-8.958-4.347-11.621-10.626-11.621M184.406 186.9c-12.195-12.225-30.995-22.045-45.912-24.218-12.552-1.83-23.45.833-29.901 7.3-4.487 4.508-6.968 10.523-6.968 16.918s2.481 12.41 6.986 16.937c6.43 6.445 17.329 9.105 29.883 7.275 14.92-2.172 33.72-11.991 45.912-24.212m141.311 60.256c8.81 7.998-4.065 24.12-34.467 25.258-40.526 1.516-61.272-21.474-76.91-45.058-5.375-8.106-10.945-17.07-17.927-25.668-32.199 32.273-79.246 39.672-102.259 16.604-8-8.042-12.947-19.137-12.947-31.392 0-12.255 4.946-23.351 12.947-31.391 23.02-23.076 69.235-16.928 101.44 15.355 3.586-5.83 6.506-12.765 8.53-20.173 2.024-7.41 3.152-15.292 3.152-23.014 0-11.328-2.29-22.12-6.433-31.935a82.173 82.173 0 0 0-17.54-26.078 81.959 81.959 0 0 0-26.016-17.582c-9.791-4.152-20.558-6.448-31.858-6.448s-22.066 2.296-31.858 6.448a81.959 81.959 0 0 0-26.016 17.582 82.206 82.206 0 0 0-17.54 26.078c-4.142 9.816-6.432 20.607-6.432 31.935 0 9.954 1.768 19.494 5.008 28.322a81.975 81.975 0 0 0 13.832 24.046 8.45 8.45 0 0 1 1.945 5.73 8.262 8.262 0 0 1-2.412 5.528l-3.535 3.543a8.225 8.225 0 0 1-6.256 2.42 8.363 8.363 0 0 1-6.02-3.006 103.6 103.6 0 0 1-17.725-30.54C24.268 152.495 22 140.352 22 127.678c0-14.315 2.893-27.952 8.127-40.356a103.858 103.858 0 0 1 22.167-32.955 103.565 103.565 0 0 1 32.876-22.22C97.544 26.9 111.148 24 125.43 24c14.28 0 27.884 2.9 40.258 8.147a103.565 103.565 0 0 1 32.876 22.22 103.842 103.842 0 0 1 22.167 32.955c5.233 12.404 8.127 26.04 8.127 40.356 0 11.253-1.789 22.087-5.098 32.231-3.224 9.89-8.538 19.512-14.512 27.012 24.248 29.36 32.192 68.234 82.74 68.234 21.184 0 33.729-7.998 33.729-7.998m254.672-75.77c0 22.831 13.095 41.34 35.971 41.34 19.866 0 36.881-12.075 36.881-41.34 0-29.343-19.568-41.338-36.88-41.338-23.218 0-35.972 18.508-35.972 41.339m-23.216.181c0-36.556 22.944-61.493 55.066-61.493 19.08 0 33.33 10.411 39.85 21.79V73.96c0-8.716 4.589-11.38 10.627-11.38h2.657c6.28 0 10.627 2.664 10.627 11.38v154.26c0 .726-3.865 2.663-8.695 2.663-7.246 0-14.733-3.874-14.974-20.094-9.178 13.557-22.462 21.788-40.816 21.788-31.156 0-54.342-23.968-54.342-61.009m-41.003-.364c0-29.263-17.014-41.338-36.88-41.338-22.876 0-35.972 18.508-35.972 41.338 0 22.83 12.754 41.339 35.971 41.339 17.313 0 36.881-11.995 36.881-41.339m22.76-56.832v150.249c0 8.714-4.348 11.378-10.627 11.378h-2.658c-6.037 0-10.626-2.664-10.626-11.378v-54.136c-8.937 13.8-22.462 22.031-40.575 22.031-31.156 0-54.342-24.451-54.342-61.25 0-36.8 22.945-61.251 55.066-61.251 19.321 0 33.57 8.957 40.092 19.61.966-14.526 8.211-17.916 14.974-17.916 4.831 0 8.695 1.936 8.695 2.663M390.156 62.885c-8.12 0-14.702 6.599-14.702 14.738 0 8.14 6.582 14.74 14.702 14.74 8.121 0 14.704-6.6 14.704-14.74s-6.583-14.738-14.704-14.738m1.329 48.825h-2.414c-6.28 0-10.87 2.905-10.87 11.62v95.63c0 8.715 4.59 11.378 10.87 11.378h2.414c6.28 0 10.627-2.663 10.627-11.378v-95.63c0-8.957-4.348-11.62-10.627-11.62M738.272 214.276c19.6 0 31.591-19.798 31.591-37.06v-5.066h-5.996c-16.371 0-47.268 1.382-47.268 23.48 0 9.208 7.377 18.646 21.673 18.646m25.365-57.857h5.996v-2.992c0-19.105-11.069-24.552-25.365-24.552-11.53 0-20.984 4.888-26.288 7.88-4.38 2.07-7.84 1.38-10.376-2.763l-1.844-3.735c-2.305-4.373-1.613-8.056 2.536-10.358 6.918-3.915 20.062-9.899 37.817-9.899 31.09 0 46.887 16.114 46.887 45.577v66.064c0 5.064-2.768 7.597-7.609 7.597h-6.766c-4.843 0-7.61-2.533-7.61-7.597v-6.906c0-4.374.692-7.135.692-7.135h-.46S760.41 232 733.2 232C712.678 232 694 219.34 694 197.472c0-36.14 45.425-41.053 69.637-41.053M810.655 208.982l2.475-3.925c2.982-3.913 5.964-4.145 10.551-1.612 5.276 3.452 14.671 9.789 28.206 9.789 11.469 0 18.453-4.967 18.453-14.865 0-22.38-59.53-14.78-59.53-54.761 0-22.098 20.261-33.608 42.97-33.608 16.058 0 26.609 5.525 32.115 8.978 4.129 2.072 4.817 5.985 2.523 10.128l-2.067 3.69c-2.294 4.143-6.255 4.568-10.613 2.496-4.818-2.762-12.592-6.509-23.603-6.509-11.01 0-18.007 4.466-18.007 14.364 0 22.588 59.872 14.285 59.872 54.555 0 20.68-17.739 34.298-42.743 34.298-19.27 0-32.573-7.825-38.996-12.66-3.9-2.532-4.129-6.445-1.606-10.358M913 69.433c0-4.955 2.467-7.433 7.4-7.433h7.945c4.71 0 7.175 2.478 7.175 7.433v60.554c0 5.407-.672 9.46-.672 9.46h.449c4.933-11.036 19.734-26.13 42.385-26.13 26.686 0 40.318 14.643 40.318 43.7v65.55c0 4.954-2.691 7.433-7.4 7.433h-8.25c-4.934 0-7.401-2.479-7.401-7.433v-60.593c0-15.993-3.364-28.608-21.528-28.608-21.753 0-37.9 18.02-37.9 42.573v46.628c0 4.954-2.467 7.433-7.176 7.433H920.4c-4.934 0-7.401-2.479-7.401-7.433V69.433z'
      })
    )
  );
};

var ScooterIcon = function ScooterIcon(props) {
  return _react2.default.createElement(
    'svg',
    _extends({
      width: '16',
      height: '16',
      viewBox: '0 0 16 10',
      xmlns: 'http://www.w3.org/2000/svg'
    }, props),
    _react2.default.createElement(
      'g',
      {
        fill: 'currentColor',
        fillRule: 'evenodd'
      },
      _react2.default.createElement('path', {
        d: 'M.338 8.179A.34.34 0 0 1 0 7.837c0-2.833 1.366-4.592 3.564-4.592 2.822 0 3.446.758 3.76 2.889.042.582.255.917.84 1.361h1.131c.736-.183 1.062-.607 1.32-1.071.77-1.385 1.242-2.015 2.446-2.015C14.68 4.41 16 5.947 16 7.837a.34.34 0 0 1-.338.342H.338zm14.963-.696c-.139-1.36-1.092-2.417-2.244-2.417-.786 0-.832 0-1.85 1.626l-.159.253a3.021 3.021 0 0 1-.404.538h4.657zM.7 7.483h6.486c-.271-.319-.433-.653-.481-.999V6.48l-.03-.219c-.32-2.207-1.046-2.32-3.095-2.32C1.857 3.94.795 5.257.7 7.483z'
      }),
      _react2.default.createElement('path', {
        d: 'M11.097 6.281a.344.344 0 0 1-.13-.465c.68-1.23.662-2.364-.054-3.372C10.113 1.318 9.596.92 9.164.686L8.287.683A.34.34 0 0 1 7.95.34.34.34 0 0 1 8.288 0l.961.003c.053 0 .105.013.152.038.522.269 1.132.698 2.06 2.004.87 1.225.908 2.619.1 4.08-.062.111-.182.2-.3.2a.335.335 0 0 1-.164-.044z'
      }),
      _react2.default.createElement('path', {
        d: 'M12.053 3.377c-.497 0-.628-.167-.672-.224a.341.341 0 0 1 .057-.477.335.335 0 0 1 .424.007c.063.016.187.018.294.012.02-.338.015-.932-.045-1.196-.177.083-.496.342-.75.618a.335.335 0 0 1-.476.017.342.342 0 0 1-.018-.48c.363-.394 1.047-1.026 1.55-.818.224.093.297.333.32.412.125.408.148 1.701.004 1.919-.078.117-.205.193-.594.208a2.272 2.272 0 0 1-.094.002M3.726 10a2.001 2.001 0 0 1-1.987-2.175.338.338 0 0 1 .336-.308h3.302c.175 0 .322.134.336.31A2 2 0 0 1 3.725 10zM2.428 8.179c.094.636.64 1.126 1.298 1.126.657 0 1.203-.49 1.297-1.126H2.428zM13.073 10a2.001 2.001 0 0 1-1.987-2.175.338.338 0 0 1 .336-.308h3.302c.175 0 .322.134.336.31A2 2 0 0 1 13.072 10h.001zm-1.298-1.821c.094.636.64 1.126 1.298 1.126.657 0 1.203-.49 1.297-1.126h-2.595z'
      })
    )
  );
};

var SearchIcon = function SearchIcon(props) {
  return _react2.default.createElement(
    'svg',
    _extends({
      width: '22',
      height: '22',
      viewBox: '0 0 22 22'
    }, props),
    _react2.default.createElement(
      'g',
      {
        fill: 'currentColor',
        fillRule: 'evenodd'
      },
      _react2.default.createElement('path', {
        d: 'M12.414 11l6.364 6.364s.707.707 0 1.414-1.414 0-1.414 0L11 12.414 12.414 11z'
      }),
      _react2.default.createElement('path', {
        d: 'M8 14A6 6 0 1 0 8 2a6 6 0 0 0 0 12zm0-1A5 5 0 1 0 8 3a5 5 0 0 0 0 10z'
      })
    )
  );
};

var SearchCrossIcon = function SearchCrossIcon(props) {
  return _react2.default.createElement(
    'svg',
    _extends({
      xmlns: 'http://www.w3.org/2000/svg',
      width: '36',
      height: '35',
      viewBox: '0 0 36 35'
    }, props),
    _react2.default.createElement(
      'g',
      {
        fill: 'none',
        fillRule: 'evenodd',
        stroke: 'currentColor',
        transform: 'translate(1 1)'
      },
      _react2.default.createElement('path', {
        strokeLinecap: 'round',
        strokeLinejoin: 'round',
        d: 'M23.917 23.917L33.9 33.9M9 9l10 10m0-10L9 19'
      }),
      _react2.default.createElement('circle', {
        cx: '14',
        cy: '14',
        r: '14'
      })
    )
  );
};

var StarIcon = function StarIcon(props) {
  return _react2.default.createElement(
    'svg',
    _extends({
      width: '10',
      height: '10',
      viewBox: '0 0 10 10',
      xmlns: 'http://www.w3.org/2000/svg'
    }, props),
    _react2.default.createElement('path', {
      d: 'M5 8.73L2.83 9.797c-.993.488-1.602.017-1.357-1.067l.55-2.439L.476 4.768c-.789-.775-.547-1.512.557-1.648l1.984-.243L4.09.766c.503-.99 1.312-1.002 1.821 0l1.074 2.11 1.984.244c1.096.135 1.346.872.557 1.648L7.977 6.29l.551 2.439c.244 1.077-.362 1.556-1.357 1.067L5 8.73z',
      fill: 'none',
      fillRule: 'evenodd'
    })
  );
};

var Stopwatch = function Stopwatch(props) {
  return _react2.default.createElement(
    'svg',
    _extends({
      width: '15',
      height: '16',
      viewBox: '0 0 15 16',
      xmlns: 'http://www.w3.org/2000/svg'
    }, props),
    _react2.default.createElement(
      'g',
      {
        fillRule: 'nonzero',
        fill: '#000'
      },
      _react2.default.createElement('path', {
        d: 'M10.287 9.578H7.27c-.14 0-.233-.09-.233-.222V5.71c0-.133.093-.222.233-.222.139 0 .232.089.232.222v3.422h2.785c.14 0 .233.09.233.223s-.093.222-.233.222zM8.5.622H6.04C5.9.622 5.806.533 5.806.4S5.9.178 6.04.178H8.5c.14 0 .232.089.232.222S8.616.622 8.5.622zM14.605 4.133a.215.215 0 0 1-.162-.066l-1.579-1.511a.209.209 0 0 1 0-.312.231.231 0 0 1 .325 0l1.579 1.512a.209.209 0 0 1 0 .31.215.215 0 0 1-.163.067z'
      }),
      _react2.default.createElement('path', {
        d: 'M7.27 15.822c-3.83 0-6.965-3-6.965-6.666 0-3.667 3.134-6.667 6.965-6.667 3.83 0 6.964 3 6.964 6.667 0 3.666-3.134 6.666-6.964 6.666zm0-12.889c-3.575 0-6.5 2.8-6.5 6.223 0 3.422 2.925 6.222 6.5 6.222s6.5-2.8 6.5-6.222c0-3.423-2.925-6.223-6.5-6.223z'
      })
    )
  );
};

var TwitterIcon = function TwitterIcon(props) {
  return _react2.default.createElement(
    'svg',
    _extends({
      width: '20',
      height: '16',
      viewBox: '0 0 20 16',
      xmlns: 'http://www.w3.org/2000/svg'
    }, props),
    _react2.default.createElement('path', {
      d: 'M17.316 4.246c.008.162.011.326.011.488 0 4.99-3.797 10.742-10.74 10.742-2.133 0-4.116-.625-5.787-1.697a7.577 7.577 0 0 0 5.588-1.562 3.779 3.779 0 0 1-3.526-2.621 3.858 3.858 0 0 0 1.705-.065 3.779 3.779 0 0 1-3.028-3.703v-.047a3.766 3.766 0 0 0 1.71.473 3.775 3.775 0 0 1-1.168-5.041 10.716 10.716 0 0 0 7.781 3.945 3.813 3.813 0 0 1-.097-.861A3.773 3.773 0 0 1 13.539.524a3.77 3.77 0 0 1 2.756 1.191 7.602 7.602 0 0 0 2.397-.916 3.789 3.789 0 0 1-1.66 2.088 7.55 7.55 0 0 0 2.168-.594 7.623 7.623 0 0 1-1.884 1.953z',
      fill: 'currentColor',
      fillRule: 'evenodd'
    })
  );
};

var WarningIcon = function WarningIcon(props) {
  return _react2.default.createElement(
    'svg',
    _extends({
      width: '20',
      height: '20',
      viewBox: '0 0 20 20',
      xmlns: 'http://www.w3.org/2000/svg'
    }, props),
    _react2.default.createElement(
      'g',
      {
        transform: 'translate(1 1)',
        fill: 'none',
        fillRule: 'evenodd'
      },
      _react2.default.createElement('ellipse', {
        stroke: 'currentColor',
        cx: '9',
        cy: '9',
        rx: '9',
        ry: '9'
      }),
      _react2.default.createElement('path', {
        d: 'M8.838 11.252h.312c.297 0 .467-.17.481-.467l.071-6.318c0-.297-.156-.467-.467-.467h-.482c-.297 0-.453.17-.453.467l.07 6.318c0 .297.17.467.468.467zm-.538 2.28c0 .312.156.468.467.468h.482c.312 0 .467-.156.467-.467v-.454c0-.311-.155-.467-.467-.467h-.482c-.311 0-.467.156-.467.467v.454z',
        fill: 'currentColor'
      })
    )
  );
};

var RepeatIcon = function RepeatIcon(props) {
  return _react2.default.createElement(
    'svg',
    _extends({
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      xmlns: 'http://www.w3.org/2000/svg'
    }, props),
    _react2.default.createElement(
      'g',
      {
        fill: 'none',
        fillRule: 'evenodd'
      },
      _react2.default.createElement('path', {
        d: 'M0 0h24v24H0z'
      }),
      _react2.default.createElement(
        'g',
        {
          stroke: 'currentColor',
          strokeLinecap: 'round',
          strokeWidth: '2'
        },
        _react2.default.createElement('path', {
          d: 'M9.644 9h5.587C16.76 9 18 10.343 18 12v4c0 1.657-1.24 3-2.77 3H8.77C7.24 19 6 17.657 6 16v-4'
        }),
        _react2.default.createElement('path', {
          strokeLinejoin: 'round',
          d: 'M13 13L9 9l4-4'
        })
      )
    )
  );
};

var CrossIcon = function CrossIcon(props) {
  return _react2.default.createElement(
    'svg',
    _extends({
      xmlns: 'http://www.w3.org/2000/svg',
      width: '20',
      height: '20',
      viewBox: '0 0 20 20'
    }, props),
    _react2.default.createElement('path', {
      d: 'M17 3L3 17M3 3l14 14',
      fill: 'currentColor',
      fillRule: 'evenodd',
      stroke: 'currentColor',
      strokeLinecap: 'round',
      strokeWidth: '2'
    })
  );
};

var ReCenter = function ReCenter(props) {
  return _react2.default.createElement(
    'svg',
    _extends({
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      xmlns: 'http://www.w3.org/2000/svg'
    }, props),
    _react2.default.createElement(
      'g',
      {
        fill: 'none',
        fillRule: 'evenodd',
        stroke: '#212339'
      },
      _react2.default.createElement('circle', {
        cx: '12',
        cy: '12',
        r: '7'
      }),
      _react2.default.createElement('circle', {
        cx: '12',
        cy: '12',
        r: '2'
      }),
      _react2.default.createElement('path', {
        d: 'M12 3v4M12 17v4M7 12H3M21 12h-4',
        strokeLinecap: 'round'
      })
    )
  );
};

var VanIcon = function VanIcon(props) {
  return _react2.default.createElement(
    'svg',
    _extends({
      width: '22',
      height: '14',
      viewBox: '0 0 22 14',
      xmlns: 'http://www.w3.org/2000/svg'
    }, props),
    _react2.default.createElement(
      'g',
      {
        fill: 'currentColor',
        fillRule: 'evenodd'
      },
      _react2.default.createElement('path', {
        d: 'M3.364 10.324v.861c.096 0 .174.01.248-.003.07-.01.174-.025.197-.07.124-.254.229-.517.344-.788h-.79zm16.317 0c.115.282.227.559.344.833.013.032.06.07.091.07.28.005.559.003.84.003v-.906h-1.275zM4.674 11.651c-.007.812.498 1.34 1.287 1.346.777.006 1.32-.512 1.326-1.267.007-.876-.475-1.4-1.292-1.403-.822-.004-1.314.49-1.32 1.324zm13.176-1.323c-.81.009-1.324.53-1.317 1.337.008.822.542 1.341 1.373 1.332.76-.009 1.27-.566 1.26-1.378-.01-.784-.536-1.3-1.316-1.291zm-10.056-.005c.11.243.244.467.313.71.054.19.14.222.31.222 1.929-.005 3.857-.003 5.785-.003h1.417l.412-.929H7.794zm7.76-9.268v3.68h3.33l-1.35-3.68h-1.98zm-.007 8.316h5.397c.01-.032.02-.052.02-.072.001-.824.01-1.649-.01-2.473-.002-.115-.117-.262-.22-.332a18.167 18.167 0 0 0-1.13-.691.799.799 0 0 0-.374-.107c-1.156-.008-2.312-.005-3.468-.005-.069 0-.137.007-.215.011v3.67zm6.344 2.493c-.149.246-.364.323-.644.309-.403-.02-.808-.005-1.217-.005-.146.49-.4.902-.781 1.225-1.194 1.01-2.907.531-3.485-.982-.067-.178-.14-.236-.329-.235-2.341.007-4.683.007-7.024 0-.189 0-.272.053-.35.24-.363.884-1.013 1.412-1.958 1.518-.813.092-1.736-.496-2.138-1.342-.07-.149-.123-.306-.187-.468-.284 0-.567.002-.85-.001-.325-.003-.495-.178-.496-.513-.002-.419 0-.838 0-1.266l-.174-.038c-.235-.05-.377-.21-.378-.45-.004-.6-.004-1.202 0-1.802.001-.274.195-.477.446-.483a.456.456 0 0 1 .46.445c.018.369.008.738.01 1.107v.248h11.8v-8.31H2.812c0 .47.005.932-.001 1.393-.005.334-.296.552-.6.451-.215-.072-.315-.245-.317-.465-.005-.616-.009-1.231.002-1.846.006-.315.198-.477.538-.478C3.528.113 4.62.113 5.713.113h10.004c.681 0 1.363-.001 2.044.003.33.001.447.103.562.417.518 1.42 1.04 2.839 1.567 4.256.029.079.107.151.18.197.343.218.688.432 1.04.634.38.218.621.539.74.962.006.025.027.047.04.07v5.212z'
      }),
      _react2.default.createElement('path', {
        d: 'M2.382 3.832h1.744c.324.002.525.178.53.461.006.293-.198.482-.532.482-1.156.002-2.311.002-3.467 0-.332 0-.547-.19-.546-.474.001-.285.213-.468.548-.469h1.723M2.386 5.694c.291 0 .582-.003.873 0 .293.003.485.182.491.451.007.274-.178.47-.469.473-.596.007-1.191.007-1.787 0-.294-.003-.473-.194-.469-.472.004-.273.192-.447.489-.452.149-.002.298-.001.447-.001h.425z'
      })
    )
  );
};

var BulkOrdersIcon = function BulkOrdersIcon(props) {
  return _react2.default.createElement(
    'svg',
    _extends({
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      xmlns: 'http://www.w3.org/2000/svg'
    }, props),
    _react2.default.createElement(
      'g',
      {
        stroke: 'currentColor',
        fill: 'none',
        fillRule: 'evenodd'
      },
      _react2.default.createElement('rect', {
        x: '6.5',
        y: '16.5',
        width: '11',
        height: '4',
        rx: '2'
      }),
      _react2.default.createElement('rect', {
        x: '6.5',
        y: '10.5',
        width: '11',
        height: '4',
        rx: '2'
      }),
      _react2.default.createElement('rect', {
        x: '6.5',
        y: '4.5',
        width: '11',
        height: '4',
        rx: '2'
      })
    )
  );
};

var AlertIcon = function AlertIcon(props) {
  return _react2.default.createElement(
    'svg',
    _extends({
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      xmlns: 'http://www.w3.org/2000/svg'
    }, props),
    _react2.default.createElement(
      'g',
      {
        fill: 'none',
        fillRule: 'evenodd'
      },
      _react2.default.createElement('path', {
        d: 'M13.723 5.11l6.995 11.875A2 2 0 0 1 18.995 20H5.005a2 2 0 0 1-1.723-3.015l6.995-11.876a2 2 0 0 1 3.446 0z',
        stroke: 'currentColor',
        strokeLinecap: 'round',
        strokeLinejoin: 'round'
      }),
      _react2.default.createElement('path', {
        d: 'M12 9a.92.92 0 0 1 .917.997l-.375 4.505a.543.543 0 0 1-1.083 0l-.376-4.505A.92.92 0 0 1 12 9z',
        fill: 'currentColor'
      }),
      _react2.default.createElement('circle', {
        fill: 'currentColor',
        cx: '12',
        cy: '17',
        r: '1'
      })
    )
  );
};

var EditIcon = function EditIcon(props) {
  return _react2.default.createElement(
    'svg',
    _extends({
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      xmlns: 'http://www.w3.org/2000/svg'
    }, props),
    _react2.default.createElement(
      'g',
      {
        fill: 'none',
        fillRule: 'evenodd'
      },
      _react2.default.createElement('path', {
        d: 'M0 0h24v24H0z'
      }),
      _react2.default.createElement(
        'g',
        {
          stroke: '#212339'
        },
        _react2.default.createElement('path', {
          d: 'M17.556 4.414l2.829 2.829a1 1 0 0 1 0 1.414l-10.371 10.37a1 1 0 0 1-.566.284l-4.62.66.66-4.62a1 1 0 0 1 .283-.566l10.371-10.37a1 1 0 0 1 1.414 0z',
          strokeLinecap: 'round',
          strokeLinejoin: 'round'
        }),
        _react2.default.createElement('path', {
          d: 'M13.997 6.511l4.293 4.294'
        })
      )
    )
  );
};

var FilterIcon = function FilterIcon(props) {
  return _react2.default.createElement(
    'svg',
    _extends({
      xmlns: 'http://www.w3.org/2000/svg',
      width: '24',
      height: '24',
      viewBox: '0 0 24 24'
    }, props),
    _react2.default.createElement(
      'g',
      {
        fill: 'none',
        fillRule: 'evenodd',
        stroke: 'currentColor'
      },
      _react2.default.createElement('circle', {
        cx: '12',
        cy: '12',
        r: '10.5'
      }),
      _react2.default.createElement('path', {
        d: 'M6 9h12M8 13h8m-6 4h4',
        strokeLinecap: 'round'
      })
    )
  );
};

var FilterActiveIcon = function FilterActiveIcon(props) {
  return _react2.default.createElement(
    'svg',
    _extends({
      xmlns: 'http://www.w3.org/2000/svg',
      width: '24',
      height: '24',
      viewBox: '0 0 24 24'
    }, props),
    _react2.default.createElement(
      'g',
      {
        fill: 'currentColor',
        fillRule: 'evenodd'
      },
      _react2.default.createElement('circle', {
        cx: '12',
        cy: '12',
        r: '11'
      }),
      _react2.default.createElement('path', {
        d: 'M6 9h12M8 13h8m-6 4h4',
        stroke: '#FFF',
        strokeLinecap: 'round'
      })
    )
  );
};

var SettingsIcon = function SettingsIcon(props) {
  return _react2.default.createElement(
    'svg',
    _extends({
      xmlns: 'http://www.w3.org/2000/svg',
      width: '24',
      height: '24',
      viewBox: '0 0 24 24'
    }, props),
    _react2.default.createElement(
      'g',
      {
        fill: 'none',
        fillRule: 'evenodd'
      },
      _react2.default.createElement('path', {
        fill: 'none',
        d: 'M.5.5h23v23H.5z'
      }),
      _react2.default.createElement('path', {
        stroke: '#FFF',
        d: 'M6.932 18.246l-1.178-1.178a.5.5 0 0 1-.07-.619l.925-1.48a6.116 6.116 0 0 1-.521-1.256l-1.7-.393A.5.5 0 0 1 4 12.833v-1.666a.5.5 0 0 1 .388-.487l1.7-.393c.127-.44.303-.862.52-1.256l-.924-1.48a.5.5 0 0 1 .07-.619l1.178-1.178a.5.5 0 0 1 .619-.07l1.48.925a6.116 6.116 0 0 1 1.256-.521l.393-1.7A.5.5 0 0 1 11.167 4h1.666a.5.5 0 0 1 .487.388l.393 1.7c.44.127.862.303 1.256.52l1.48-.924a.5.5 0 0 1 .619.07l1.178 1.178a.5.5 0 0 1 .07.619l-.925 1.48c.218.394.394.815.521 1.256l1.7.393a.5.5 0 0 1 .388.487v1.666a.5.5 0 0 1-.388.487l-1.7.393a6.116 6.116 0 0 1-.52 1.256l.924 1.48a.5.5 0 0 1-.07.619l-1.178 1.178a.5.5 0 0 1-.619.07l-1.48-.925a6.116 6.116 0 0 1-1.256.521l-.393 1.7a.5.5 0 0 1-.487.388h-1.666a.5.5 0 0 1-.487-.388l-.393-1.7a6.116 6.116 0 0 1-1.256-.52l-1.48.924a.5.5 0 0 1-.619-.07z'
      }),
      _react2.default.createElement('circle', {
        cx: '12',
        cy: '12',
        r: '2',
        stroke: '#FFF'
      })
    )
  );
};

var LogoutIcon = function LogoutIcon(props) {
  return _react2.default.createElement(
    'svg',
    _extends({
      xmlns: 'http://www.w3.org/2000/svg',
      width: '24',
      height: '24',
      viewBox: '0 0 24 24'
    }, props),
    _react2.default.createElement(
      'g',
      {
        fill: 'none',
        fillRule: 'evenodd'
      },
      _react2.default.createElement('path', {
        fill: 'none',
        d: 'M.5.5h23v23H.5z'
      }),
      _react2.default.createElement(
        'g',
        {
          stroke: 'currentColor',
          strokeLinecap: 'round'
        },
        _react2.default.createElement('path', {
          d: 'M8 9V6c0-1.105.746-2 1.667-2h6.666C17.253 4 18 4.895 18 6v12c0 1.105-.746 2-1.667 2H9.667C8.747 20 8 19.105 8 18v-3'
        }),
        _react2.default.createElement('path', {
          strokeLinejoin: 'round',
          d: 'M5 14l-1.757-1.5a.636.636 0 0 1 0-1L5 10m-2 2h8'
        })
      )
    )
  );
};

var AddressBookIcon = function AddressBookIcon(props) {
  return _react2.default.createElement(
    'svg',
    _extends({
      xmlns: 'http://www.w3.org/2000/svg',
      width: '24',
      height: '24',
      viewBox: '0 0 24 24'
    }, props),
    _react2.default.createElement(
      'g',
      {
        fill: 'none',
        fillRule: 'evenodd',
        stroke: 'currentColor'
      },
      _react2.default.createElement('path', {
        d: 'M6 2h13.462C20.312 2 21 2.689 21 3.538v16.924c0 .85-.689 1.538-1.538 1.538H6V2z'
      }),
      _react2.default.createElement('path', {
        d: 'M9 16h8m-8 2h6',
        strokeLinecap: 'round'
      }),
      _react2.default.createElement('path', {
        d: 'M6 22H4.5c-.828 0-1.5-.689-1.5-1.538V3.538C3 2.688 3.672 2 4.5 2H6m7.5 7a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm-1.74 3a.764.764 0 0 1-.76-.77v-.245c0-.87.651-1.582 1.479-1.65a.628.628 0 0 1 .253.037 2.37 2.37 0 0 0 1.536 0 .628.628 0 0 1 .253-.037c.828.068 1.479.78 1.479 1.65v.246a.767.767 0 0 1-.76.769h-3.48z'
      })
    )
  );
};

var PoundIcon = function PoundIcon(props) {
  return _react2.default.createElement(
    'svg',
    _extends({
      xmlns: 'http://www.w3.org/2000/svg',
      width: '7',
      height: '10',
      viewBox: '0 0 7 10'
    }, props),
    _react2.default.createElement(
      'text',
      {
        fill: '#212339',
        fillRule: 'evenodd',
        fontFamily: 'MuseoSansRounded-500, Museo Sans Rounded',
        fontSize: '12',
        opacity: '.4',
        transform: 'translate(-6 -5)'
      },
      _react2.default.createElement(
        'tspan',
        {
          x: '5.236',
          y: '15.296'
        },
        '\xA3'
      )
    )
  );
};

var LogoV2Icon = function LogoV2Icon(props) {
  return _react2.default.createElement(
    'svg',
    _extends({
      xmlns: 'http://www.w3.org/2000/svg',
      width: '259',
      height: '64',
      viewBox: '0 0 259 64'
    }, props),
    _react2.default.createElement(
      'g',
      {
        fill: 'none',
        fillRule: 'evenodd'
      },
      _react2.default.createElement('path', {
        fill: '#6C65F7',
        d: 'M17.01 60.033c9.287 4.946 20.53 4.946 29.843 0a.474.474 0 0 0 .106-.767L32.435 44.747c-.291-.29-.741-.29-1.006 0l-14.524 14.52c-.238.21-.185.607.106.766zm42.965-13.117c4.947-9.283 4.947-20.523 0-29.832a.474.474 0 0 0-.767-.105L44.683 31.498c-.29.29-.29.74 0 1.004l14.525 14.52c.211.238.608.185.767-.106zM3.889 17.084c-4.947 9.283-4.947 20.523 0 29.832.159.29.53.344.767.105L19.18 32.502c.291-.29.291-.74 0-1.004L4.656 16.978c-.211-.238-.608-.185-.767.106zm53.784-2.644a.72.72 0 0 0 .08-.926c-1.006-1.375-2.117-2.724-3.36-3.967C44.287-.555 29.022-2.433 17.037 3.967a.474.474 0 0 0-.105.767L41.668 29.46c.29.291.74.291 1.005 0l15-15.021z'
      }),
      _react2.default.createElement('path', {
        fill: '#FFD100',
        d: 'M39.578 31.498L14.365 6.294a.721.721 0 0 0-.926-.08c-1.375 1.006-2.724 2.117-3.968 3.36a31.745 31.745 0 0 0-3.36 3.966c-.211.291-.158.662.08.926l17.566 17.56L6.27 49.507a.881.881 0 0 0-.08 1.138 31.855 31.855 0 0 0 3.281 3.834 31.86 31.86 0 0 0 3.836 3.28c.344.264.82.211 1.138-.08l17.99-17.983 1.349-1.349 4.55-4.549 1.244-1.243c.29-.317.29-.793 0-1.057z'
      }),
      _react2.default.createElement('path', {
        fill: '#6C65F7',
        d: 'M63.388 56.516l-6.932 6.929c-.344.343-.9.343-1.217 0l-20.767-20.76c-.291-.292-.291-.741 0-1.006l7.143-7.14c.29-.291.74-.291 1.005 0l20.768 20.76a.846.846 0 0 1 0 1.217z'
      }),
      _react2.default.createElement(
        'g',
        {
          fill: '#E9EEFA'
        },
        _react2.default.createElement('path', {
          d: 'M126.907 23.008h4.233c.238 0 .424.185.424.423v14.123c0 4.998 2.777 7.88 7.725 7.88 2.38 0 4.365-.74 5.9-2.22 1.534-1.429 2.274-3.333 2.274-5.66V23.43c0-.238.186-.423.424-.423h4.233c.238 0 .423.185.423.423v25.39a.418.418 0 0 1-.423.423h-4.154a.418.418 0 0 1-.423-.423v-2.486h-.106c-2.037 2.38-5.424 3.676-9.471 3.676-6.376-.027-11.535-5.236-11.535-11.61V23.431a.509.509 0 0 1 .476-.423z'
        }),
        _react2.default.createElement('path', {
          fillRule: 'nonzero',
          d: 'M157.675 13.117h4.736c.238 0 .423.185.423.423v4.496a.418.418 0 0 1-.423.424h-4.736a.418.418 0 0 1-.423-.424V13.54c-.027-.238.185-.423.423-.423zm.344 9.891h4.233c.238 0 .423.185.423.423V48.82a.418.418 0 0 1-.423.423h-4.233a.418.418 0 0 1-.423-.423V23.43c-.027-.211.185-.423.423-.423z'
        }),
        _react2.default.createElement('path', {
          d: 'M200.057 23.008h4.233c.238 0 .423.185.423.423v14.123c0 4.998 2.778 7.88 7.725 7.88 2.381 0 4.365-.74 5.9-2.22 1.534-1.429 2.275-3.333 2.275-5.66V23.43c0-.238.185-.423.423-.423h4.233c.238 0 .423.185.423.423v25.39a.418.418 0 0 1-.423.423h-4.1a.418.418 0 0 1-.424-.423v-2.486h-.106c-2.037 2.38-5.423 3.676-9.47 3.676-6.376-.027-11.535-5.236-11.535-11.61V23.431c0-.211.185-.423.423-.423z'
        }),
        _react2.default.createElement('path', {
          fillRule: 'nonzero',
          d: 'M231.169 23.008h4.153c.238 0 .424.185.424.423v2.54h.105c2.037-2.328 5.344-3.703 9.313-3.703 7.672 0 13.571 6.003 13.571 13.858.16 7.775-6.058 14.016-13.73 13.857-3.757 0-7.222-1.428-9.074-3.57h-.106v13.54a.418.418 0 0 1-.423.424h-4.233a.418.418 0 0 1-.424-.423V23.458c0-.238.186-.45.424-.45zm13.492 3.782c-4.947 0-8.81 3.412-8.81 7.59v3.57c0 4.152 3.757 7.59 8.678 7.59 5.344 0 9.127-3.755 9.127-9.361-.026-5.74-3.65-9.389-8.995-9.389zm-49.974-3.332V59.98a.418.418 0 0 1-.424.423h-4.233a.418.418 0 0 1-.423-.423V46.44h-.106c-1.825 2.142-5.29 3.57-9.074 3.57-7.672.159-13.863-6.083-13.73-13.858 0-7.88 5.9-13.858 13.571-13.858 3.969 0 7.276 1.375 9.313 3.703h.105v-2.54c0-.237.186-.422.424-.422h4.153c.212-.027.424.185.424.423zm-22.911 12.694c0 5.607 3.757 9.362 9.127 9.362 4.894 0 8.678-3.412 8.678-7.59v-3.57c0-4.152-3.863-7.59-8.81-7.59-5.37.026-8.995 3.676-8.995 9.388zm-48.969-4.232c.158-10.26-7.54-18.274-17.99-18.089-10.344-.185-18.096 7.829-17.937 18.09-.159 10.26 7.593 18.274 17.937 18.089 3.81.08 7.222-.952 10.053-2.75l2.725 2.723c.159.16.45.16.608 0l2.725-2.723a.448.448 0 0 0 0-.609l-2.46-2.46c2.804-3.226 4.418-7.51 4.339-12.27zm-17.99 13.277c-7.381 0-12.54-5.342-12.54-13.276s5.159-13.276 12.54-13.276c7.434 0 12.593 5.342 12.593 13.276 0 3.411-.953 6.32-2.62 8.568l-8.042-8.04a.448.448 0 0 0-.608 0l-2.725 2.725a.448.448 0 0 0 0 .608l7.83 7.828c-1.851 1.031-4.02 1.587-6.428 1.587z'
        })
      )
    )
  );
};

var QLogoV2Icon = function QLogoV2Icon(props) {
  return _react2.default.createElement(
    'svg',
    _extends({
      xmlns: 'http://www.w3.org/2000/svg',
      width: '128',
      height: '128',
      viewBox: '0 0 128 128'
    }, props),
    _react2.default.createElement(
      'g',
      {
        fill: 'none',
        fillRule: 'evenodd'
      },
      _react2.default.createElement('path', {
        fill: '#6C65F7',
        d: 'M34.022 120.066c18.572 9.891 41.059 9.891 59.684 0 .582-.317.687-1.058.211-1.534L64.87 89.494c-.582-.582-1.481-.582-2.01 0l-29.05 29.038c-.476.423-.37 1.217.212 1.534zm85.928-26.235c9.894-18.565 9.894-41.044 0-59.662-.318-.582-1.059-.688-1.535-.212L89.367 62.995c-.582.582-.582 1.481 0 2.01l29.048 29.038c.423.476 1.217.37 1.535-.212zM7.778 34.169c-9.894 18.565-9.894 41.044 0 59.662.317.582 1.058.688 1.534.212l29.049-29.038c.582-.582.582-1.481 0-2.01L9.312 33.957c-.423-.476-1.217-.37-1.534.212zm107.568-5.289c.476-.477.582-1.27.159-1.852-2.01-2.75-4.233-5.448-6.72-7.934C88.573-1.11 58.044-4.866 34.075 7.934c-.582.317-.688 1.058-.212 1.534l49.472 49.454c.582.582 1.482.582 2.01 0l30.001-30.043z'
      }),
      _react2.default.createElement('path', {
        fill: '#FFD100',
        d: 'M79.155 62.995L28.731 12.588c-.476-.476-1.27-.581-1.852-.158-2.752 2.01-5.45 4.231-7.937 6.717a63.49 63.49 0 0 0-6.72 7.934c-.423.582-.317 1.322.16 1.851l35.132 35.12L12.54 99.016c-.582.582-.688 1.587-.159 2.274a63.71 63.71 0 0 0 6.561 7.67 63.72 63.72 0 0 0 7.672 6.558c.688.53 1.64.423 2.275-.158l35.98-35.967 2.699-2.698 9.1-9.097 2.487-2.486c.582-.635.582-1.587 0-2.116z'
      }),
      _react2.default.createElement('path', {
        fill: '#6C65F7',
        d: 'M126.775 113.031l-13.863 13.858c-.687.688-1.799.688-2.434 0L68.943 85.37c-.582-.582-.582-1.481 0-2.01L83.23 69.078c.582-.582 1.482-.582 2.01 0l41.536 41.52a1.692 1.692 0 0 1 0 2.433z'
      })
    )
  );
};

var LogoV2GhostIcon = function LogoV2GhostIcon(props) {
  return _react2.default.createElement(
    'svg',
    _extends({
      xmlns: 'http://www.w3.org/2000/svg',
      width: '259',
      height: '64',
      viewBox: '0 0 259 64'
    }, props),
    _react2.default.createElement(
      'g',
      {
        fill: 'none',
        fillRule: 'evenodd'
      },
      _react2.default.createElement('path', {
        fill: '#6C65F7',
        d: 'M17.01 60.033c9.287 4.946 20.53 4.946 29.843 0a.474.474 0 0 0 .106-.767L32.435 44.747c-.291-.29-.741-.29-1.006 0l-14.524 14.52c-.238.21-.185.607.106.766zm42.965-13.117c4.947-9.283 4.947-20.523 0-29.832a.474.474 0 0 0-.767-.105L44.683 31.498c-.29.29-.29.74 0 1.004l14.525 14.52c.211.238.608.185.767-.106zM3.889 17.084c-4.947 9.283-4.947 20.523 0 29.832.159.29.53.344.767.105L19.18 32.502c.291-.29.291-.74 0-1.004L4.656 16.978c-.211-.238-.608-.185-.767.106zm53.784-2.644a.72.72 0 0 0 .08-.926c-1.006-1.375-2.117-2.724-3.36-3.967C44.287-.555 29.022-2.433 17.037 3.967a.474.474 0 0 0-.105.767L41.668 29.46c.29.291.74.291 1.005 0l15-15.021z'
      }),
      _react2.default.createElement('path', {
        fill: '#FFD100',
        d: 'M39.578 31.498L14.365 6.294a.721.721 0 0 0-.926-.08c-1.375 1.006-2.724 2.117-3.968 3.36a31.745 31.745 0 0 0-3.36 3.966c-.211.291-.158.662.08.926l17.566 17.56L6.27 49.507a.881.881 0 0 0-.08 1.138 31.855 31.855 0 0 0 3.281 3.834 31.86 31.86 0 0 0 3.836 3.28c.344.264.82.211 1.138-.08l17.99-17.983 1.349-1.349 4.55-4.549 1.244-1.243c.29-.317.29-.793 0-1.057z'
      }),
      _react2.default.createElement('path', {
        fill: '#6C65F7',
        d: 'M63.388 56.516l-6.932 6.929c-.344.343-.9.343-1.217 0l-20.767-20.76c-.291-.292-.291-.741 0-1.006l7.143-7.14c.29-.291.74-.291 1.005 0l20.768 20.76a.846.846 0 0 1 0 1.217z'
      }),
      _react2.default.createElement(
        'g',
        {
          fill: '#23005B'
        },
        _react2.default.createElement('path', {
          d: 'M126.907 23.008h4.233c.238 0 .424.185.424.423v14.123c0 4.998 2.777 7.88 7.725 7.88 2.38 0 4.365-.74 5.9-2.22 1.534-1.429 2.274-3.333 2.274-5.66V23.43c0-.238.186-.423.424-.423h4.233c.238 0 .423.185.423.423v25.39a.418.418 0 0 1-.423.423h-4.154a.418.418 0 0 1-.423-.423v-2.486h-.106c-2.037 2.38-5.424 3.676-9.471 3.676-6.376-.027-11.535-5.236-11.535-11.61V23.431a.509.509 0 0 1 .476-.423z'
        }),
        _react2.default.createElement('path', {
          fillRule: 'nonzero',
          d: 'M157.675 13.117h4.736c.238 0 .423.185.423.423v4.496a.418.418 0 0 1-.423.424h-4.736a.418.418 0 0 1-.423-.424V13.54c-.027-.238.185-.423.423-.423zm.344 9.891h4.233c.238 0 .423.185.423.423V48.82a.418.418 0 0 1-.423.423h-4.233a.418.418 0 0 1-.423-.423V23.43c-.027-.211.185-.423.423-.423z'
        }),
        _react2.default.createElement('path', {
          d: 'M200.057 23.008h4.233c.238 0 .423.185.423.423v14.123c0 4.998 2.778 7.88 7.725 7.88 2.381 0 4.365-.74 5.9-2.22 1.534-1.429 2.275-3.333 2.275-5.66V23.43c0-.238.185-.423.423-.423h4.233c.238 0 .423.185.423.423v25.39a.418.418 0 0 1-.423.423h-4.1a.418.418 0 0 1-.424-.423v-2.486h-.106c-2.037 2.38-5.423 3.676-9.47 3.676-6.376-.027-11.535-5.236-11.535-11.61V23.431c0-.211.185-.423.423-.423z'
        }),
        _react2.default.createElement('path', {
          fillRule: 'nonzero',
          d: 'M231.169 23.008h4.153c.238 0 .424.185.424.423v2.54h.105c2.037-2.328 5.344-3.703 9.313-3.703 7.672 0 13.571 6.003 13.571 13.858.16 7.775-6.058 14.016-13.73 13.857-3.757 0-7.222-1.428-9.074-3.57h-.106v13.54a.418.418 0 0 1-.423.424h-4.233a.418.418 0 0 1-.424-.423V23.458c0-.238.186-.45.424-.45zm13.492 3.782c-4.947 0-8.81 3.412-8.81 7.59v3.57c0 4.152 3.757 7.59 8.678 7.59 5.344 0 9.127-3.755 9.127-9.361-.026-5.74-3.65-9.389-8.995-9.389zm-49.974-3.332V59.98a.418.418 0 0 1-.424.423h-4.233a.418.418 0 0 1-.423-.423V46.44h-.106c-1.825 2.142-5.29 3.57-9.074 3.57-7.672.159-13.863-6.083-13.73-13.858 0-7.88 5.9-13.858 13.571-13.858 3.969 0 7.276 1.375 9.313 3.703h.105v-2.54c0-.237.186-.422.424-.422h4.153c.212-.027.424.185.424.423zm-22.911 12.694c0 5.607 3.757 9.362 9.127 9.362 4.894 0 8.678-3.412 8.678-7.59v-3.57c0-4.152-3.863-7.59-8.81-7.59-5.37.026-8.995 3.676-8.995 9.388zm-48.969-4.232c.158-10.26-7.54-18.274-17.99-18.089-10.344-.185-18.096 7.829-17.937 18.09-.159 10.26 7.593 18.274 17.937 18.089 3.81.08 7.222-.952 10.053-2.75l2.725 2.723c.159.16.45.16.608 0l2.725-2.723a.448.448 0 0 0 0-.609l-2.46-2.46c2.804-3.226 4.418-7.51 4.339-12.27zm-17.99 13.277c-7.381 0-12.54-5.342-12.54-13.276s5.159-13.276 12.54-13.276c7.434 0 12.593 5.342 12.593 13.276 0 3.411-.953 6.32-2.62 8.568l-8.042-8.04a.448.448 0 0 0-.608 0l-2.725 2.725a.448.448 0 0 0 0 .608l7.83 7.828c-1.851 1.031-4.02 1.587-6.428 1.587z'
        })
      )
    )
  );
};

var BellIcon = function BellIcon(props) {
  return _react2.default.createElement(
    'svg',
    _extends({
      width: '40',
      height: '32',
      viewBox: '0 0 40 32',
      fill: 'none',
      xmlns: 'http://www.w3.org/2000/svg'
    }, props),
    _react2.default.createElement('path', {
      d: 'M31.599 19.118l.011.131.035.127c1.02 3.756 2.877 5.886 4.357 7.584l.128.148c1.079 1.24 1.845 2.175 2.18 3.392H1.923c.115-.213.253-.433.416-.666.504-.715 1.153-1.414 1.917-2.235l.429-.463c1.807-1.957 4.025-4.51 4.203-8.24.276-5.795 1.402-10.196 3.278-13.105C13.983 2.975 16.528 1.5 20 1.5c3.466 0 6.008 1.471 7.883 4.322 1.938 2.946 3.178 7.403 3.716 13.296z',
      fill: '#fff',
      fillOpacity: '.28',
      stroke: '#fff',
      strokeWidth: '3'
    })
  );
};

function QuIcon(_ref) {
  var icon = _ref.icon,
      width = _ref.width,
      height = _ref.height,
      className = _ref.className,
      rest = _objectWithoutProperties(_ref, ['icon', 'width', 'height', 'className']);

  return _react2.default.createElement(
    'span',
    _extends({ className: getClassName({ icon: icon, className: className }) }, rest),
    renderSvg({ icon: icon, width: width, height: height })
  );
}

function renderSvg(_ref2) {
  var icon = _ref2.icon,
      width = _ref2.width,
      height = _ref2.height;

  switch (icon) {
    case 'logo':
      return _react2.default.createElement(LogoIcon, { width: width, height: height });
    case 'logo-v2':
      return _react2.default.createElement(LogoV2Icon, { width: width, height: height });
    case 'q-logo-v2':
      return _react2.default.createElement(QLogoV2Icon, { width: width, height: height });
    case 'logo-v2-ghost':
      return _react2.default.createElement(LogoV2GhostIcon, { width: width, height: height });
    case 'q-logo':
      return _react2.default.createElement(QLogoIcon, { width: width, height: height });
    case 'quiqdash-logo':
      return _react2.default.createElement(QuiqdashLogoIcon, { width: width, height: height });
    case 'arrow-right':
      return _react2.default.createElement(ArrowRightIcon, { width: width, height: height });
    case 'bicycle':
      return _react2.default.createElement(BikeIcon, { width: width, height: height });
    case 'check':
      return _react2.default.createElement(CheckIcon, { width: width, height: height });
    case 'check-v2':
      return _react2.default.createElement(CheckIconV2, { width: width, height: height });
    case 'scooter':
      return _react2.default.createElement(ScooterIcon, { width: width, height: height });
    case 'car':
      return _react2.default.createElement(CarIcon, { width: width, height: height });
    case 'van':
      return _react2.default.createElement(VanIcon, { width: width, height: height });
    case 'chevron-down':
      return _react2.default.createElement(ChevronDownIcon, { width: width, height: height });
    case 'phone':
      return _react2.default.createElement(PhoneIcon, { width: width, height: height });
    case 'location':
      return _react2.default.createElement(LocationIcon, { width: width, height: height });
    case 'item-box':
      return _react2.default.createElement(ItemBoxIcon, { width: width, height: height });
    case 'calendar':
      return _react2.default.createElement(CalendarIcon, { width: width, height: height });
    case 'arrow-back':
      return _react2.default.createElement(ArrowBackIcon, { width: width, height: height });
    case 'card':
      return _react2.default.createElement(CardIcon, { width: width, height: height });
    case 'search':
      return _react2.default.createElement(SearchIcon, { width: width, height: height });
    case 'search-cross':
      return _react2.default.createElement(SearchCrossIcon, { width: width, height: height });
    case 'warning':
      return _react2.default.createElement(WarningIcon, { width: width, height: height });
    case 'instagram':
      return _react2.default.createElement(InstagramIcon, { width: width, height: height });
    case 'twitter':
      return _react2.default.createElement(TwitterIcon, { width: width, height: height });
    case 'facebook':
      return _react2.default.createElement(FacebookIcon, { width: width, height: height });
    case 'bin':
      return _react2.default.createElement(BinIcon, { width: width, height: height });
    case 'paper-plane':
      return _react2.default.createElement(PaperPlane, { width: width, height: height });
    case 'star':
      return _react2.default.createElement(StarIcon, { width: width, height: height });
    case 'android':
      return _react2.default.createElement(AndroidIcon, { width: width, height: height });
    case 'apple':
      return _react2.default.createElement(AppleIcon, { width: width, height: height });
    case 'chevron-up':
      return _react2.default.createElement(ChevronUpIcon, { width: width, height: height });
    case 'chevron-right':
      return _react2.default.createElement(ChevronRightIcon, { width: width, height: height });
    case 'chevron-left':
      return _react2.default.createElement(ChevronLeftIcon, { width: width, height: height });
    case 'pin':
      return _react2.default.createElement(PinIcon, { width: width, height: height });
    case 'profile':
      return _react2.default.createElement(ProfileIcon, { width: width, height: height });
    case 'clock':
      return _react2.default.createElement(ClockIcon, { width: width, height: height });
    case 'heart':
      return _react2.default.createElement(HeartIcon, { width: width, height: height });
    case 'comment':
      return _react2.default.createElement(CommentIcon, { width: width, height: height });
    case 'stopwatch':
      return _react2.default.createElement(Stopwatch, { width: width, height: height });
    case 'list-move':
      return _react2.default.createElement(ListMove, { width: width, height: height });
    case 'building-pin':
      return _react2.default.createElement(BuildingPin, { width: width, height: height });
    case 'repeat':
      return _react2.default.createElement(RepeatIcon, { width: width, height: height });
    case 'cross':
      return _react2.default.createElement(CrossIcon, { width: width, height: height });
    case 're-center':
      return _react2.default.createElement(ReCenter, { width: width, heigh: height });
    case 'bulk-orders':
      return _react2.default.createElement(BulkOrdersIcon, { width: width, height: height });
    case 'alert':
      return _react2.default.createElement(AlertIcon, { width: width, height: height });
    case 'edit':
      return _react2.default.createElement(EditIcon, { width: width, height: height });
    case 'filter':
      return _react2.default.createElement(FilterIcon, { width: width, height: height });
    case 'filter-active':
      return _react2.default.createElement(FilterActiveIcon, { width: width, height: height });
    case 'settings':
      return _react2.default.createElement(SettingsIcon, { width: width, height: height });
    case 'logout':
      return _react2.default.createElement(LogoutIcon, { width: width, height: height });
    case 'address-book':
      return _react2.default.createElement(AddressBookIcon, { width: width, height: height });
    case 'pound':
      return _react2.default.createElement(PoundIcon, { width: width, height: height });
    case 'bell':
      return _react2.default.createElement(BellIcon, { width: width, height: height });
    default:
      console.error('Missing icon: ' + icon);
      return null;
  }
}

function getClassName(_ref3) {
  var icon = _ref3.icon,
      className = _ref3.className;

  return 'qu-icon var-' + icon + ' ' + className;
}

QuIcon.propTypes = {
  className: _propTypes2.default.string,
  icon: _propTypes2.default.string.isRequired,
  width: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
  height: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string])
};

QuIcon.defaultProps = {
  className: '',
  height: '1em'
};

exports.default = QuIcon;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@quiqupltd/qu-react-sdk/lib/components/qu-icon/index.js
// module id = 53
// module chunks = 0